import React, { useMemo, useState } from "react";
import { Button, message, Select } from "antd";
import { useChannelStore, useGlobalStore } from "@obsbot/remo-stores";
import { useTranslate } from "@obsbot/remo-i18n";
import { CustomModal } from "../../CustomModal";

export interface InviteChannelProps {
    onClose: () => void;
    onConfirm: (channelID: string, channelUUID: string) => void;
}

// eslint-disable-next-line react/display-name
export const InviteToChannel: React.FC<InviteChannelProps> = ({ onClose, onConfirm }) => {
    const t = useTranslate();
    const { channels } = useChannelStore();
    const { userInfo } = useGlobalStore();
    const options = useMemo(() => {
        const tempOptions = [];
        for (const [, value] of channels.entries()) {
            if (value.ownerUuid === userInfo?.user_id) {
                tempOptions.push({
                    uuid: value.channelUuid,
                    value: value.inviteFlag,
                    label: value.channelName,
                    title: "",
                });
            }
        }
        return tempOptions;
    }, [channels, userInfo?.user_id]);
    const [activeChannel, setActiveChannel] = useState<{
        uuid: string;
        value: string;
        label: string;
        title: string;
    }>(options?.[0]);

    console.log("channels", channels);
    const onClick = (): void => {
        if (!activeChannel) {
            message.error(t("channel.channel-id-empty"));
            return;
        }
        const channels = useChannelStore.getState().channels;
        const channel = channels.get(activeChannel.uuid);
        if (!channel) {
            return;
        }
        onConfirm(channel.inviteFlag, activeChannel.uuid);
    };
    return (
        <CustomModal
            classNames={{
                content: "invite-modal-content",
            }}
            destroyOnHidden={true}
            footer={
                <Button type="primary" onClick={onClick}>
                    {t("confirm")}
                </Button>
            }
            open={true}
            renderHeader={t("channel.invite-to-channel")}
            setVisible={visible => visible}
            width={400}
            onCancel={onClose}
        >
            <Select
                className="invite-select"
                options={options}
                value={activeChannel.value}
                onChange={e => {
                    const channel = options.find(item => item.value === e);
                    setActiveChannel(channel as any);
                }}
            />
        </CustomModal>
    );
};
